import api from '@/services/api'

const controlAcceso = {
  // Modulos / submodulos
  listarModulos:        ()           => api.get('/control-acceso/modulos').then(r => r.data),
  crearModulo:          (data)       => api.post('/control-acceso/modulos', data).then(r => r.data),
  actualizarModulo:     (id, data)   => api.put(`/control-acceso/modulos/${id}`, data).then(r => r.data),
  eliminarModulo:       (id)         => api.delete(`/control-acceso/modulos/${id}`).then(r => r.data),

  crearSubmodulo:       (data)       => api.post('/control-acceso/submodulos', data).then(r => r.data),
  actualizarSubmodulo:  (id, data)   => api.put(`/control-acceso/submodulos/${id}`, data).then(r => r.data),
  eliminarSubmodulo:    (id)         => api.delete(`/control-acceso/submodulos/${id}`).then(r => r.data),

  // Planes
  listarPlanes:         ()           => api.get('/control-acceso/planes').then(r => r.data),
  obtenerPlan:          (id)         => api.get(`/control-acceso/planes/${id}`).then(r => r.data),
  crearPlan:            (data)       => api.post('/control-acceso/planes', data).then(r => r.data),
  actualizarPlan:       (id, data)   => api.put(`/control-acceso/planes/${id}`, data).then(r => r.data),
  eliminarPlan:         (id)         => api.delete(`/control-acceso/planes/${id}`).then(r => r.data),
  setSubmodulosPlan:    (id, ids)    => api.put(`/control-acceso/planes/${id}/submodulos`, { submodulo_ids: ids }).then(r => r.data),

  // Suscripciones
  listarSuscripcionesEmpresa: (empId)        => api.get(`/control-acceso/empresas/${empId}/suscripciones`).then(r => r.data),
  crearSuscripcionEmpresa:    (empId, data)  => api.post(`/control-acceso/empresas/${empId}/suscripciones`, data).then(r => r.data),
  cambiarEstadoSuscripcion:   (id, estado)   => api.put(`/control-acceso/suscripciones/${id}/estado`, { estado }).then(r => r.data),

  // Roles y permisos
  listarRoles:                ()             => api.get('/control-acceso/roles').then(r => r.data),
  obtenerRol:                 (id)           => api.get(`/control-acceso/roles/${id}`).then(r => r.data),
  crearRol:                   (data)         => api.post('/control-acceso/roles', data).then(r => r.data),
  actualizarRol:              (id, data)     => api.put(`/control-acceso/roles/${id}`, data).then(r => r.data),
  eliminarRol:                (id)           => api.delete(`/control-acceso/roles/${id}`).then(r => r.data),
  setPermisosRol:             (id, permisos) => api.put(`/control-acceso/roles/${id}/permisos`, { permisos }).then(r => r.data),

  // Asignacion de roles
  setRolesUsuario:    (uid, rolIds) => api.put(`/control-acceso/usuarios/${uid}/roles`, { rol_ids: rolIds }).then(r => r.data),
  permisosUsuario:    (uid)         => api.get(`/control-acceso/usuarios/${uid}/permisos`).then(r => r.data),
}

export default controlAcceso
